"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMonitorsOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M10 5H2v8h8zm-2 6H4V7h4zM20 5h-8v8h8zm-2 6h-4V7h4zM22 5v8h8V5zm6 6h-4V7h4zM10 15H2v8h8zm-2 6H4v-4h4zM22 23h8v-8h-8zm2-6h4v4h-4z" }),
        React.createElement("path", { d: "M17 23h3v-8h-8v8h3v3H8v2h16v-2h-7zm-3-2v-4h4v4z" })));
}
exports.default = SvgMonitorsOutline;
//# sourceMappingURL=MonitorsOutline.js.map